import { useState, useCallback } from 'react';

import { CatalogDetails } from 'components';

type Tab = {
  id: string;
  label: string;
};

const Catalog = () => {
  const [currentTab, setCurrentTab] = useState<Tab>({
    label: 'Asiakirjatilaukset',
    id: 'document_order_services',
  });

  const handleChangeTab = useCallback((tab: Tab) => {
    setCurrentTab(tab);
  }, []);

  return (
    <CatalogDetails currentTab={currentTab} handleChangeTab={handleChangeTab} />
  );
};

export default Catalog;
